import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const CaretLeftIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "caret-left",
  "CaretLeftIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M4.6665 8L10.9998 12L10.9998 4L4.6665 8Z" fill={colorList[0]} fillOpacity="0.9"/></g></svg>
);

export default CaretLeftIcon;
